import wos from 'apis/wos';
import { PhotoUpload } from '.';

export const bulkCreate = async (imageUrls: string[], imageNames: string[], collection: string) => {
  const { data } = await wos.post<PhotoUpload[]>('/uploads/bulk_create.json', {
    imageUrls,
    imageNames,
    collection,
  });

  return data;
};

export const all = async () => {
  const { data } = await wos.get<PhotoUpload[]>('/uploads.json');
  return data;
};

export const find = async (id: number) => {
  const { data } = await wos.get<PhotoUpload>(`/uploads/${id}.json`);
  return data;
};

export const update = async (id: number, upload: Partial<PhotoUpload>) => {
  const { data } = await wos.put<PhotoUpload>(`/uploads/${id}.json`, { upload });
  return data;
};

export const sort = async (ids: number[]) => {
  const params = `ids=${encodeURIComponent(ids.join(','))}`;
  const headers = { 'content-type': 'application/x-www-form-urlencoded;charset=utf-8' };

  await wos.post('/uploads/set_order.json', params, { headers });
  return;
};

export const destroy = async (id: number) => {
  await wos.delete(`/uploads/${id}.json`);
  return;
};

export const destroyMany = async (ids: number[]) => {
  await Promise.all(ids.map((id) => destroy(id)));
  return;
};
